import type { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';
import { forwardRef, useImperativeHandle, useRef } from 'react';

const TextArea = forwardRef<
  HTMLTextAreaElement,
  DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & {
    error?: unknown;
  }
>(({ error: _error, ...props }, ref): JSX.Element => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useImperativeHandle(ref, () => textAreaRef.current as HTMLTextAreaElement);

  return (
    <div className="flex">
      <textarea
        {...props}
        id={props.id || props.name}
        name={props.name}
        ref={textAreaRef}
        className="w-full resize-none rounded-md p-2 text-sm shadow-sm ring-1 ring-zinc-300 ring-inset focus:border-emerald-500 focus:outline-hidden focus:ring-2 focus:ring-emerald-500 dark:border-white/10 dark:bg-white/5 dark:text-white dark:focus:ring-emerald-400 dark:focus:ring-offset-zinc-800"
      />
    </div>
  );
});

TextArea.displayName = 'TextArea';

export default TextArea;
